import React from "react";
import Layout from "../../layout/Layout";
import Banner from "../Home/Banner";
import PopularMovies from "../Home/PopularMovies";
import Promo from "../Home/Promo";
import TopRatedMovies from "../Home/TopRatedMovies";

const Home = () => {
  return (
    <Layout>
      <div className="container mx-auto min-h-screen px-2 mb-6">
        <Banner />
        <PopularMovies />
        <Promo />
        <TopRatedMovies />
      </div>
    </Layout>
  );
};

export default Home;
